export const Remove = () => {
  return (
    <svg viewBox="-1 -1 24 24" height="24" width="24">
      <path
        d="m4.125 17.875 13.75 -13.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      ></path>
      <path
        d="m4.125 4.125 13.75 13.75"
        fill="none"
        stroke="currentColor"
        strokeLinecap="round"
        strokeLinejoin="round"
        strokeWidth="2"
      ></path>
    </svg>
  );
};
